import React, { memo } from 'react';
import { PRIMARY } from '../utils/parameterUtils';

/**
 * GenerateFooter - Footer with num images stepper and generate button
 * Memoized to prevent unnecessary re-renders
 */
const GenerateFooter = memo(function GenerateFooter({
  numImages,
  maxImages = 4,
  onNumImagesChange,
  onGenerate,
  generating,
  isUploading,
  canGenerate,
}) {
  return (
    <div
      style={{
        padding: 16,
        paddingBottom: 'calc(env(safe-area-inset-bottom, 16px) + 16px)',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      {/* Num images stepper */}
      <div
        role="group"
        aria-label="Number of images to generate"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '10px 14px',
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 10,
        }}
      >
        <button
          onClick={() => onNumImagesChange(Math.max(1, numImages - 1))}
          aria-label="Decrease number of images"
          disabled={numImages <= 1}
          style={{
            width: 24,
            height: 24,
            borderRadius: 6,
            background: 'transparent',
            border: 'none',
            color: numImages <= 1 ? '#4a4a4a' : '#9ca3af',
            fontSize: 18,
            cursor: numImages <= 1 ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          −
        </button>
        <span 
          aria-live="polite"
          aria-atomic="true"
          style={{ fontSize: 14, fontWeight: 600, color: '#fff', minWidth: 24, textAlign: 'center' }}
        >
          {numImages}/{maxImages}
        </span>
        <button
          onClick={() => onNumImagesChange(Math.min(maxImages, numImages + 1))}
          aria-label="Increase number of images"
          disabled={numImages >= maxImages}
          style={{
            width: 24,
            height: 24,
            borderRadius: 6,
            background: 'transparent',
            border: 'none',
            color: numImages >= maxImages ? '#4a4a4a' : '#9ca3af',
            fontSize: 18,
            cursor: numImages >= maxImages ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          +
        </button>
      </div>
      
      {/* Generate Button */}
      <button
        onClick={onGenerate}
        disabled={generating || isUploading || !canGenerate}
        aria-busy={generating || isUploading}
        aria-disabled={!canGenerate}
        style={{
          flex: 1,
          padding: '14px 20px',
          background: (generating || isUploading || !canGenerate) ? '#2a2a2a' : PRIMARY,
          border: 'none',
          borderRadius: 10,
          color: (generating || isUploading || !canGenerate) ? '#666' : '#fff',
          fontSize: 16,
          fontWeight: 600,
          cursor: (generating || isUploading || !canGenerate) ? 'not-allowed' : 'pointer',
        }}
      >
        {generating ? 'Generating...' : isUploading ? 'Uploading...' : 'Generate'}
      </button>
    </div>
  );
});

export default GenerateFooter;
